import graphql__80c91dd4d7885d0ef561 from "./__generated__/ContributionsDatavizListItemsTheme_theme.graphql.js";
import graphql__4ed5e680e99b6cb34b34 from "./__generated__/ContributionsDatavizListItemsTheme_participativeModule.graphql.js";import { useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../../../Intl/Context";
import { useNavigateTo } from "../../../Routes/RoutesContext";
import { Desktop, useResponsiveFlag } from "../../../Utils/ResponsiveQueries";
import Icon from "../../../Utils/Icon";
import { themePathFor } from "../../../Utils/themePathFor";
import ButtonDiv from "../../../Buttons/ButtonDiv";
import ContributionsDatavizThemeMeasures from "./ContributionsDatavizThemeMeasures";

const ContributionsDatavizListItemsTheme = props => {
  const theme = useFragment(ContributionsDatavizListItemsTheme_theme, props.theme);

  const { slug: participativeModuleSlug } = useFragment(
    ContributionsDatavizListItemsTheme_participativeModule,
    props.participativeModule
  );
  const { rootTheme } = themePathFor(theme);

  const t = useFormatMessage();
  const seeContributionsLabel = t(intlMessages.seeContributions);

  const navigateTo = useNavigateTo();
  const navigateToTheme = useCallback(
    ({ slug: themeSlug }) =>
      navigateTo("datavizListTheme", { participativeModuleSlug, themeSlug }),
    [navigateTo, participativeModuleSlug]
  );

  const { isDesktop, isNonDesktop } = useResponsiveFlag();

  const themeButtonClassName = classNames(
    "btn",
    "btn-block",
    "btn-unstyled",
    "box",
    "padding-y-xs",
    "padding-x-sm",
    {
      "margin-bottom-sm": isDesktop,
      "margin-bottom-md": isNonDesktop
    }
  );

  const iconClassName = classNames(["align-middle", theme.iconClass]);
  const { primaryColor, primaryContrastColor } = theme;

  return (
    <article>
      <ButtonDiv
        className={themeButtonClassName}
        data-dataviz-list-view-subtheme-button
        onClick={() => navigateToTheme(theme)}
        role="link"
      >
        <div className="dataviz-box-top-label">
          <div
            className="theme"
            style={{
              backgroundColor: primaryColor,
              color: primaryContrastColor
            }}
          >
            {rootTheme.name}
          </div>
        </div>
        <div className="d-flex align-items-center margin-bottom-xxs">
          <div
            className="flex-shrink-0 icon big margin-right-xs text-center text-greater"
            style={{
              backgroundColor: primaryColor,
              color: primaryContrastColor
            }}
          >
            <Icon className={iconClassName} />
          </div>
          <div>
            <h3 className="text-subtitle-section font-weight-bold">{theme.name}</h3>
          </div>
        </div>
        <div className="d-flex align-items-center line-height-1">
          <ContributionsDatavizThemeMeasures theme={theme} className="flex-1" />

          <Desktop>
            <div className="line-height-1 text-primary d-flex align-items-center">
              <span className="margin-right-xxs pointer text-uppercase">
                {seeContributionsLabel}
              </span>
              <Icon className="icon-arrow-right align-middle pointer" />
            </div>
          </Desktop>
        </div>
      </ButtonDiv>
    </article>
  );
};

const ContributionsDatavizListItemsTheme_theme = graphql__80c91dd4d7885d0ef561;

const ContributionsDatavizListItemsTheme_participativeModule = graphql__4ed5e680e99b6cb34b34;

export default ContributionsDatavizListItemsTheme;

const intlMessages = defineMessages({
  seeContributions: {
    id: "participativeModule.contributionsDataviz.listItems.seeContributions",
    defaultMessage: "voir les contributions"
  }
});
